if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor () {
      super()
      this.formEl = this.closest('.main-product__form')
      this.form = this.querySelector('form')
      this.isSet = this.form.querySelector('[name=top-id]')
      if (this.isSet) {
        this.form.querySelector('[name=top-id]').disabled = false
        this.form.querySelector('[name=bottom-id]').disabled = false
      } else {
        this.form.querySelector('[name=id]').disabled = false
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      this.submitButton = this.querySelector('[type="submit"]')
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')

      this.formEl.querySelector('.prd-Colours')?.addEventListener('click', this.onColourClick.bind(this))
    }

    getExistingSetId (variantIds) {
      const cartSetItems = [...document.querySelectorAll('.cart-item.product-set:not(.visually-hidden)')]
      const matchingSetItem = cartSetItems.find(item => {
        return item.dataset.setVariantIds === variantIds
      })

      if (matchingSetItem) {
        const setId = parseInt(matchingSetItem.dataset.setId.split('-')[1])
        return setId
      }
      return false
    }

    onSubmitHandler (evt) {
      evt.preventDefault()

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      this.handleErrorMessage()

      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

      const quickAddModal = this.closest('quick-add-modal')

      if (quickAddModal) {
        if (this.submitButton.dataset.notifyMe === 'true') {
          quickAddModal.querySelector('.product__view-details').click()
        }
      }

      // eslint-disable-next-line no-undef
      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      if (this.isSet) {
        config.headers['Content-Type'] = 'application/json'
      } else {
        delete config.headers['Content-Type']
      }

      const formData = new FormData(this.form)
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id),
        )
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }
      if (this.isSet) {
        this.setGroups = this.formEl.querySelectorAll('set-variant-radios')
        let setInfo = ''
        let groupDetails = ''

        this.setGroups.forEach(group => {
          if (group.options[0].toLowerCase() === 'top') {
            groupDetails = group.currentVariant.title
            setInfo = setInfo + groupDetails.replace(' / Normal", " :: ')
            if (!setInfo.includes(' :: ')) {
              setInfo = `${setInfo} :: `
            }
          }
          if (group.options[0].toLowerCase() === 'bottom') {
            groupDetails = group.currentVariant.title
            setInfo = setInfo + groupDetails
          }
        })

        const existingSetId = this.getExistingSetId(`${formData.get('top-id')}-${formData.get('bottom-id')}`)
        const setId = existingSetId || Math.floor((Math.random() * 1000000) + 1000)

        const props = JSON.parse(`
          {
            "_setID": "${formData.get('top-id')}-${setId}",
            "_setInfo": "${setInfo}"
          }`,
        )
        props._topVariantId = formData.get('top-id')
        props._bottomVariantId = formData.get('bottom-id')
        props._setVariantIds = `${formData.get('top-id')}-${formData.get('bottom-id')}`
        props._setId = setId

        if (formData.get('_deliveryMessage') !== '') {
          props._deliveryMessage = `${formData.get('_deliveryMessage')}`
        }

        const itemsArr = [
          {
            id: formData.get('top-id'),
            quantity: 1,
            properties: { ...props, _setItemType: 'top' },
          },
          {
            id: formData.get('bottom-id'),
            quantity: 1,
            properties: { ...props, _setItemType: 'bottom' },
          },
        ]

        config.body = JSON.stringify({
          sections: formData.get('sections'),
          sections_url: formData.get('sections_url'),
          items: itemsArr,
        })
      } else {
        config.body = formData
      }

      // eslint-disable-next-line no-undef
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return
            this.submitButton.setAttribute('aria-disabled', true)
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          } else if (!this.cart) {
            window.location = window.routes.cart_url
            return
          }

          this.error = false
          const quickAddModal = this.closest('quick-add-modal')

          if (quickAddModal) {
            this.cart.renderContents(response)
            quickAddModal.remove()

            document.dispatchEvent(new CustomEvent('add-to-cart-quick-add', { bubbles: true, detail: response }))
          } else {
            this.cart.renderContents(response)
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.submitButton.classList.remove('loading')
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
          if (!this.error) this.submitButton.removeAttribute('aria-disabled')
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden')

          const pushToDataLayer = window.BAO.Utils.pushToDataLayer || function () {}
          const price = document.querySelector('[data-gtm-el="main-product-details"] [data-gtm-el-price]')?.dataset.gtmElPrice || 0

          pushToDataLayer('pinterest_add_to_cart', {
            pinterest_currency: window.Shopify?.currency.active || 'USD',
            pinterest_order_value: price,
            pinterest_line_items: [{
              product_id: formData.get('product-id'),
              product_category: evt.target.dataset.gtmProductCategory || '',
            }],
          })

          const event = new CustomEvent('product-added-to-cart')
          document.dispatchEvent(event)
        })
    }

    handleErrorMessage (errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      if (!this.errorMessageWrapper) return
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      if (!this.dataset.enableNotify) {
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }

    onColourClick (e) {
      const target = e.target.closest('.prd-Colours_Link')

      if (!target) return

      const colour = target.dataset.colour

      window.dispatchEvent(new CustomEvent('pdp-colour-change', {
        detail: {
          colour,
        },
      }))
    }
  })
}
